import React from 'react'
import closeIcon from '../../../../assets/CreditCheckOTP/img/newclose.gif'

const OTPFail = ({ show }) => {
    return (
        <>
            <div className={`all-screen screen4 otp-card p-4 ${show ? "show" : "hide"}`}>
                <div className="card-body text-white">
                    <img src={closeIcon} className="img-fluid mt-4 mb-3 success-tick close-icon" alt="security-icon" />
                    <h3 className="text-center">Verification Failed</h3>
                    <p>Sorry, the OTP you entered is invalid. Please try again later</p>
                </div>
            </div>
        </>
    )
}

export default OTPFail